module.exports = __webpack_public_path__ + "static/tqmwebsitebanner-c27888ee0fe239b998be1d54576d18d3.png";